import { mediaArticleTemplate, type MediaDraft } from "./media";

/** Export authored content and its evidence without transport IDs or execution metadata. */
export function mediaDraftText(draft: MediaDraft): string {
  const paragraphs: string[] = [draft.title, "Private draft"];
  if (draft.type === "article") {
    paragraphs.push(draft.dek, draft.thesis);
    mediaArticleTemplate.sections.forEach(section => paragraphs.push(section.heading, ...draft.sections[section.id]));
  } else {
    const walk = (value: unknown, key = "") => {
      if (/evidenceNumbers|EvidenceNumbers/.test(key)) return;
      if (typeof value === "string") paragraphs.push(value);
      else if (typeof value === "number" && /Second$|Minute$|Seconds$|Minutes$/.test(key)) paragraphs.push(`${key.replace(/([A-Z])/g, " $1")}: ${value}`);
      else if (Array.isArray(value)) value.forEach(item => walk(item, key));
      else if (value && typeof value === "object") Object.entries(value).forEach(([name, item]) => walk(item, name));
    };
    walk(draft.content);
  }
  paragraphs.push("Evidence", ...draft.citations.map(citation => `[${citation.number}] ${citation.title}${citation.url ? ` — ${citation.url}` : ""}`));
  if (draft.limitations.length) paragraphs.push("Limitations", ...draft.limitations);
  return paragraphs.filter(Boolean).join("\n\n");
}
